export const GET_PERMISSIONS_BEGIN = 'GET_PERMISSIONS_BEGIN'
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS'
export const GET_PERMISSIONS_ERROR = 'GET_PERMISSIONS_ERROR'

export const GET_ASSIGNED_PERMISSIONS_BEGIN = 'GET_ASSIGNED_PERMISSIONS_BEGIN'
export const GET_ASSIGNED_PERMISSIONS_SUCCESS = 'GET_ASSIGNED_PERMISSIONS_SUCCESS'
export const GET_ASSIGNED_PERMISSIONS_ERROR = 'GET_ASSIGNED_PERMISSIONS_ERROR'

export const ASSIGN_PERMISSION_BEGIN = 'ASSIGN_PERMISSION_BEGIN'
export const ASSIGN_PERMISSION_SUCCESS = 'ASSIGN_PERMISSION_SUCCESS'
export const ASSIGN_PERMISSION_ERROR = 'ASSIGN_PERMISSION_ERROR'

export const UNASSIGN_PERMISSION_BEGIN = 'UNASSIGN_PERMISSION_BEGIN'
export const UNASSIGN_PERMISSION_SUCCESS = 'UNASSIGN_PERMISSION_SUCCESS'
export const UNASSIGN_PERMISSION_ERROR = 'UNASSIGN_PERMISSION_ERROR'